/** Hasan Islamic Center — API expects this exact db string (space between 6 and 9). */
export const HASAN_ISLAMIC_INQUIRY_DB = "/r6Q0RYpjke6 9jYs9ARCAqxcDNPSiW0";

/** Legacy typo in some links/QR encodings (6A9 instead of "6 9"). */
const HASAN_ISLAMIC_INQUIRY_DB_LEGACY_A9 = "/r6Q0RYpjke6A9jYs9ARCAqxcDNPSiW0";

export const HASAN_ISLAMIC_INQUIRY_ROUTE_NAME = "school-inquiry-hasan";

export const HASAN_ISLAMIC_INQUIRY_PATH = "/inquiry/hasan";

export const HASAN_ISLAMIC_INQUIRY_ALT_PATH = "/hasan-inquiry";

export const MULTI_CAMPUS_INQUIRY_DBS = [HASAN_ISLAMIC_INQUIRY_DB];

export function normalizeInquiryDb(db) {
  return String(db || "")
    .trim()
    .replace(/\s+/g, "");
}

export function isHasanIslamicInquiryDb(db) {
  const key = normalizeInquiryDb(db);
  return (
    key === normalizeInquiryDb(HASAN_ISLAMIC_INQUIRY_DB) ||
    key === normalizeInquiryDb(HASAN_ISLAMIC_INQUIRY_DB_LEGACY_A9)
  );
}

/** Value to send on campuses/classes API (canonical Hasan db). */
export function resolveInquiryDb(db) {
  if (isHasanIslamicInquiryDb(db)) {
    return HASAN_ISLAMIC_INQUIRY_DB;
  }
  return String(db || "").trim();
}

export function isHasanIslamicShortInquiryRoute(route) {
  if (!route) return false;
  if (route.name === HASAN_ISLAMIC_INQUIRY_ROUTE_NAME) return true;
  const path = String(route.path || "")
    .replace(/\/+$/, "")
    .toLowerCase();
  return (
    path === HASAN_ISLAMIC_INQUIRY_PATH.toLowerCase() ||
    path === HASAN_ISLAMIC_INQUIRY_ALT_PATH.toLowerCase()
  );
}

/** Short public URL for QR / copy (Hasan Islamic only). */
export function buildHasanIslamicPublicInquiryUrl(origin = "") {
  const base = String(origin || "").replace(/\/+$/, "");
  return `${base}${HASAN_ISLAMIC_INQUIRY_PATH}`;
}
